import { pageToDataLayerInfo } from '../utils';
import { addToDataLayer, type DataLayerEvent } from '..';

export type NavigationEvent = Partial<NordicNest.Api.MenuItemApiModel> & {
  to?: string;
  menu_type?: string;
  menu_category?: string;
};

export function addNavigationEventToDataLayer(data: NavigationEvent) {
  const ga4Event: DataLayerEvent = {
    event: 'main_navigation',
    event_info: {
      content_id: data.id,
      content_link: data.to ?? data.link?.to,
      content_type: data.name,
      menu_type: data.menu_type,
      menu_category: data.menu_category,
      event_description: data.name,
      ...pageToDataLayerInfo(),
    },
  };
  addToDataLayer(ga4Event);
}
